<template>
  <v-dialog v-model="previewUnitDialog" width="700" persistent>
    <v-card>
      <v-card-title
        class="headline lighten-2 justify-content-between"
        primary-title
      >
        {{ unfinishedAssignments ? 'Assignments' : 'Preview Units' }}
        <v-btn
          @click="togglePreviewDialog"
          color="error"
          class="float-right"
          text
        >
          <v-icon x-small>fas fa-times m-1</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <div
          v-for="(unit, index) in units.slice(0, slice)"
          class="row"
          :key="index"
        >
          <div class="col">
            <router-link
              :to="{
                name: 'UnitPage',
                params: { id: unit.unit.id },
              }"
            >
              <h5>
                {{ unit.unit.name }}
                {{
                  unfinishedAssignments
                    ? ' (' + unit.unit.module.name + ' Module)'
                    : ''
                }}
                <v-chip
                  v-show="getStatus(unit)"
                  class="mb-2"
                  dark
                  small
                  :color="chipColors[getStatus(unit)]"
                >
                  <v-avatar
                    v-show="chipIcons[getStatus(unit)]"
                    left
                    :color="chipColors[getStatus(unit)]"
                  >
                    <i :class="chipIcons[getStatus(unit)]"></i>
                  </v-avatar>
                  {{ getStatus(unit) }}
                </v-chip>
              </h5>
            </router-link>
            <template v-if="unfinishedAssignments">
              {{ unit.user.name }}'s Assignment
            </template>
            <p class="subtitle-1">
              Due Date:
              <strong>
                {{ unit.due_date | displayDateTime }}
              </strong>
            </p>
            <p class="mfo">
              <i class="far fa-clock" />
              {{ unit.unit.video_duration }}
            </p>
            <p>
              {{ unit.unit.description }}
              <router-link
                :to="{
                  name: 'UnitPage',
                  params: { id: unit.unit.id },
                }"
              >
                <v-btn x-small text color="error"> Proceed to Unit </v-btn>
              </router-link>
            </p>
          </div>
        </div>
        <div class="kt-widget19__action text-center" v-if="units.length > 3">
          <v-btn
            @click="slice = slice + 5"
            text
            color="primary"
            small
            v-if="slice < units.length"
          >
            Show More
          </v-btn>
          <v-btn @click="slice = 5" text color="primary" small v-else>
            Show Less
          </v-btn>
        </div>
        <p class="text-center" v-if="units.length == 0">No unit available</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="togglePreviewDialog"> Close </v-btn>
        <v-btn
          color="primary"
          v-if="!unfinishedAssignments"
          text
          @click="goToModules(moduleId)"
        >
          Proceed to {{ isModulePage ? 'Module' : 'Category' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixins from '../../../mixins';
import dayjs from 'dayjs';

export default {
  name: 'PreviewUnitsDialog',
  props: {
    moduleId: Number,
    units: Array,
    previewUnitDialog: Boolean,
    togglePreviewDialog: Function,
    isModulePage: Boolean,
    unfinishedAssignments: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      slice: 5,
      showMore: false,
      chipColors: {
        Completed: 'yellow darken-3',
        Played: 'blue darken-3',
        'Quiz Not Answered': 'red darken-1',
      },
      chipIcons: {
        Rewatched: 'fas fa-clock-rotate-left',
        Completed: 'fas fa-badge-check',
        Played: 'fal fa-tv',
        'Quiz Not Answered': 'fa fa-exclamation',
        Assigned: 'fal fa-users-cog',
        Shared: 'fal fa-share',
      },
    };
  },
  computed: {},
  watch: {
    slice: function (val) {
      if (val) {
      } else {
      }
    },
  },
  methods: {
    renderBanner(series) {
      if (!series.highlight_unit) {
        return series.units[0].unit;
      }

      let highlight = series.units.filter((unit) => {
        return unit.unit_id == series.highlight_unit;
      });

      return highlight[0].unit;
    },
    getStatus(item) {
      let unit = item.unit;

      return this.unitStatus(unit);
    },
    goToModules(id) {
      this.$router.push({
        name: this.isModulePage ? 'CertificationModulePage' : 'Course Page',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
